import { Skeleton } from '@epilot/concorde-elements'

import classes from '../../Skeleton.module.scss'

export const PersonalInformationFormSkeleton = () => {
  return (
    <div className={classes.root}>
      <div className={classes.gridRow}>
        {/* Mimics the salutation fields */}
        <div className={classes.gridColumn}>
          <Skeleton className={classes.inputSize} style={{ width: '260px' }}>
            &nbsp;
          </Skeleton>
          <Skeleton className={classes.inputSize} style={{ width: '228px' }}>
            &nbsp;
          </Skeleton>
        </div>
        {/* Mimics first and last name fields */}
        <div className={classes.gridColumn}>
          <Skeleton className={classes.inputSize}>&nbsp;</Skeleton>
          <Skeleton className={classes.inputSize}>&nbsp;</Skeleton>
        </div>
        {/* Mimics email address field */}
        <div className={classes.gridColumn}>
          <Skeleton className={classes.inputSize}>&nbsp;</Skeleton>
        </div>
      </div>
    </div>
  )
}
